import React from 'react'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'

export default function EstimacionUnidadValor (props) {
  const { toneladas, camiones, unidad } = props

  const isFlipped = unidad === 'CAMIONES'

  return (
    <div
      className={`flip-card-container ${isFlipped ? 'flipped' : ''}`}
      style={{ cursor: 'default' }}
    >
      <div className='flip-card-inner'>
        <div className='flip-card-front'>
          <span style={{ fontWeight: 'bold', width: 'max-content' }}>{toneladas.toLocaleString()} tn</span>
        </div>

        <div className='flip-card-back'>
          <span style={{ fontWeight: 'bold', width: 'max-content' }}>{camiones} <LocalShippingIcon /></span>
        </div>
      </div>
    </div>
  )
}
